<template>
  <v-card color="grey lighten-4" style="margin-bottom:12px;" flat tile>

    <v-navigation-drawer class="hidden-sm-and-up" v-if="checkPerm('view management')" v-model="sidebar" app>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6" @click.prevent="goto('/')">
            {{$t("shopName")}}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>

                <v-list-item
                v-for="item in manageitems"
                :key="item.link"
                link
                 :to="item.link"
              >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ $t(item.label) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>

    <v-toolbar app>
      <span class="hidden-md-and-up"  v-if="checkPerm('view management')">
        <v-app-bar-nav-icon @click="sidebar = !sidebar">
        </v-app-bar-nav-icon>
      </span>
      <div class="hidden-md-and-down" id="logo" @click.prevent="goto('/')"/> <v-toolbar-title style="cursor:pointer;" @click.prevent="goto('/')">{{$t("shopName")}}</v-toolbar-title>

      <v-spacer></v-spacer>
  <v-toolbar-items v-if="checkPerm('view management')" class="hidden-sm-and-down">
         <v-btn
         v-for="item in manageitems" :key="item.link"
          flat
          :to="item.link">
          <v-icon left dark>{{ item.icon }}</v-icon>
          {{  $t(item.label) }}
        </v-btn>
      </v-toolbar-items>


      <v-spacer></v-spacer>

    <v-text-field 
    class="hidden-md-and-down"
    :label="$t('search')"
    hide-details
    single-line
    v-model="search"
    append-icon="mdi-magnify"
    @click:append="clickSearch"></v-text-field>&nbsp;

        <v-badge
          v-if="checkPerm('view management')"
          :content="notifications.count"
          :value="notifications.count"
          color="orange lighten-1"
          overlap
        >
          <v-menu offset-y >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
		:title="$t('account')"
			icon
          v-bind="attrs"
          v-on="on"
        >
        <v-icon> mdi-bell</v-icon>
        </v-btn>
      </template>
      <v-list v-if="notifications.count > 0">
        <v-list-item link v-for="noti in notifications.notis" :key="noti">
          <v-list-item-title @click.prevent="goto('/management/user/'+noti.user_id)"><v-icon>mdi-account</v-icon> {{noti.amount}}x {{ noti.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-list v-else>
        <v-list-item>
          {{$t("noNotifications")}}
        </v-list-item>
      </v-list>
    </v-menu>
    </v-badge>


        <v-badge
          :content="cart"
          :value="cart"
          color="orange lighten-1"
          overlap>
        <v-btn icon :title="$t('cart')">
          <v-icon @click.prevent="goto('/cart')">mdi-cart</v-icon>
        </v-btn>
    </v-badge>


	    <v-menu offset-y offset-x="20">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
		:title="$t('account')"
			icon
          v-bind="attrs"
          v-on="on"
        >
        <v-icon>mdi-account-circle</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
         <v-list-item-title>{{$t("hello")}} {{$store.getters.user.firstname}} {{$store.getters.user.lastname}}</v-list-item-title> 
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item link @click.prevent="goto('/checkout')">
          <v-list-item-title><v-icon>mdi-cart</v-icon> {{ $t("checkoutHistory") }}</v-list-item-title>
        </v-list-item>
        <v-list-item link @click.prevent="goto('/settings')">
          <v-list-item-title><v-icon>mdi-cog</v-icon> {{ $t("settings") }}</v-list-item-title>
        </v-list-item>
        <v-list-item link @click.prevent="goto('/logout')">
          <v-list-item-title><v-icon>mdi-logout</v-icon> {{ $t("logout") }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    </v-toolbar>
  </v-card>
</template>

<script>
import PermissionService from "@/services/PermissionService.js"
import ApiService from "@/services/ApiService.js"
export default {
  data() {
    return {
      tab: "error",
	  search: "",
      sidebar: false,
      items: [
		  {label: "home", link: "/", perm: null, icon: "mdi-home"},
		  { label: "products", link: "/products", perm: "view product", icon: "mdi-store" },
		  { label: "management", link: "/management", perm: "edit product", icon: "mdi-warehouse" },
		  ],
	  checkManageitems: [
		//   { label: "stats", link: "/management/stats", perm: "view stats", icon: "mdi-chart-areaspline" },
		  { label: "products", link: "/management/products", perm: "edit product", icon: "mdi-warehouse" },
		  { label: "categories", link: "/management/categories", perm: "edit category", icon: "mdi-tag-multiple" },
		  { label: "user", link: "/management/users", perm: "edit user", icon: "mdi-account-group" },
		  { label: "groups", link: "/management/groups", perm: "edit group", icon: "mdi-key-chain" },
	  ],
    manageitems: [],
    notifications: {
        count: 0
      },
      cart: 0
    };
  },
  props: {
    updateNotis: {
      type: Number,
      default: 0
    }
  },
  async created(){
    this.checkNotifications()
    this.checkManageitems.forEach(el => {
      if(this.checkPerm(el.perm)){
        this.manageitems.push(el)
      }
    });
  },
  methods: {
	  checkPerm(perm){
		  if(perm == "" || perm == null) return true
		  if(PermissionService.checkPermission(perm, false) )return true
		  return false
	  },
	  goto(link){
		this.$router.push(link)
	  },
	  clickSearch(){
		  this.$router.push({path:"/",query:{search: this.search}})
		  // this.$emit("searchClicked", this.search)
	  },
    async checkNotifications(){
    let resp = await ApiService.getCartAmount()
    if(resp.status == 200){
      this.cart = resp.data.amount
    }
    if(this.checkPerm("view management")){
      let res = await ApiService.getNotifications();
      if(res.status == 200){
        this.notifications.notis = res.data.users
        this.notifications.count = res.data.amount
        this.$forceUpdate();
      }
      }
    }
  },
  watch: {
    updateNotis: function() {
      this.checkNotifications()
    } 
  }
};
</script>

<style>
  #logo {
    background-image: url("https://cdn.lan1.eu/logos/lan1_logo_color.png");
    background-repeat: no-repeat;
    background-size: 140px 60px;
    height: 71px;
    left: 5px;
    margin: 10px auto;
    position: relative;
    top: 5px;
    width: 160px;
    cursor: pointer;
  }
  .always-black {
	  color: #757575 !important;
  }
</style>